<script lang="ts">
	import { _ } from 'svelte-i18n';

	import Modal from '$lib/components/Modal/Modal.svelte';
	import Size from '$lib/components/Modal/size';
	import Button from '$lib/components/Button/Button.svelte';

	export let title = '';
	export let content = '';
	export let contentMinWidth = '';
	export let contentTextAlign = '';
	export let cancelText = $_('common.cancel');
	export let submitText = $_('common.ok');
	export let onCancel: (() => void) | undefined = undefined;
	export let onSubmit = () => {
		/* Empty function */
	};
	export let isOpen = false;

	let style = '';
	if (contentMinWidth) {
		style += `min-width: ${contentMinWidth};`;
	}
	if (contentTextAlign) {
		style += `text-align: ${contentTextAlign}`;
	}
</script>

<Modal type={Size.Small} showCloseButton={false} onClose={onCancel} {isOpen}>
	<div slot="target">
		<slot />
	</div>
	<div class="title" slot="title">{title}</div>
	<div class="content" slot="content">
		<div class="text" {style}>
			{content}
		</div>
		<div class="body">
			<slot name="body" />
		</div>
		<div class="footer">
			{#if onCancel}
				<div class="button">
					<Button
						on:click={() => {
							isOpen = false;
							onCancel && onCancel();
						}}
						displayType="secondary">{cancelText}</Button>
				</div>
			{/if}
			<div class="button">
				<Button
					on:click={() => {
						isOpen = false;
						onSubmit();
					}}>{submitText}</Button>
			</div>
		</div>
	</div>
</Modal>

<style>
	.title {
		inline-size: 100%;
		opacity: 0.7;
		text-align: start;
	}

	.text {
		display: flex;
		align-items: center;
		justify-content: center;
		inline-size: fit-content;
		margin: 2rem;
		opacity: 0.8;
	}

	.body {
		margin: 2rem;
	}

	.footer {
		display: flex;
		justify-content: flex-end;
		margin-block: 0;
		margin-inline: 1rem;
	}

	.button {
		margin-block: 2rem;
		margin-inline: 1rem;
	}
</style>
